import React from 'react'
import {
  Div, H4,
} from 'konsys-ui'
import { theme } from '../../../styles/_variables'

export const DisplayTextWhenEmpty = ({ height, text, error }) => (
  <Div width='100%' height={height} padding={!height && '56px 0'} display='flex' alignItems='center' justifyContent='center'>
    <H4 color={theme.color.paleGray}>{error ? 'Something went wrong' : text}</H4>
  </Div>
)

export default DisplayTextWhenEmpty



// WEBPACK FOOTER //
// ./src/components/common/apollo-return/index.jsx